export default {
  submitText: '提交',
  emptyBtn: false,
  group: [
    {
      dialogDirection: 'rtl',
      arrow: false,
      column: [
        {
          label: '班组名称',
          prop: 'groupId',
          type: 'tree',
          dicUrl: 'api/inspectGroup/inspectGroupTree',
          props: { label: 'groupName', value: 'id' },
          rules: [
            {
              required: true,
              message: '选择班组名称',
              trigger: 'change',
            },
          ],
        },
        {
          label: '班组负责人',
          prop: 'groupPrincipalId',
          type: 'tree',
          dicUrl: 'api/blade-user/userTree',
          props: { label: 'realName', value: 'id' },
          disabled: true,
        },
        {
          label: '巡检点位名称',
          prop: 'nodeName',
          display: false,
          disabled: true,
        },
        {
          label: '巡检点位名称',
          prop: 'nodeId',
          type: 'tree',
          dicUrl: 'api/inspectNode/inspectNodeTree',
          props: { label: 'nodeName', value: 'id' },
          disabled: true,
        },
        {
          label: '任务Id',
          prop: 'taskId',
          display: false,
          editDisplay: false,
          rules: [
            {
              required: true,
              message: '请输入任务Id',
              trigger: 'change',
            },
          ],
        },
        {
          label: '巡视开始时间',
          type: 'datetime',
          prop: 'inspectBeginTime',
          format: 'yyyy-MM-dd HH:mm:ss',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          disabled: true,
          rules: [
            {
              required: true,
              message: '请输入巡视开始时间',
              trigger: 'change',
            },
          ],
        },
        {
          label: '巡视结束时间',
          type: 'datetime',
          prop: 'inspectEndTime',
          format: 'yyyy-MM-dd HH:mm:ss',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          disabled: true,
          rules: [
            {
              required: true,
              message: '请输入巡视结束时间',
              trigger: 'change',
            },
          ],
        },
        {
          label: '实际巡检时间',
          prop: 'actualInspectTime',
          disabled: true,
        },
        {
          label: '实际巡检人姓名',
          prop: 'actualUserId',
          type: 'tree',
          dicUrl: 'api/blade-user/userTree',
          props: { label: 'realName', value: 'id' },
          disabled: true,
        },
        {
          label: '任务状态',
          prop: 'taskStatus',
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=task_status',
          disabled: true,
          props: { label: 'dictValue', value: 'dictKey' },
        },
        {
          label: '是否异常',
          prop: 'errorFlag',
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=error_flag',
          props: { label: 'dictValue', value: 'dictKey' },
          disabled: true,
        },
        {
          label: '异常描述',
          prop: 'errorContent',
          type: 'textarea',
          disabled: true,
          maxlength: 200,
          span: 24,
          row: 4,
          showWordLimit: true,
        },
        {
          label: '备注',
          prop: 'remark',
          type: 'textarea',
          maxlength: 200,
          span: 24,
          row: 4,
          showWordLimit: true,
        },
      ],
    },
  ],
};
